
import React from 'react'
import DashBody from '../../Layout/Dashboard/DashBody'
import DashHeader from '../../Layout/Dashboard/DashHeader'
import LyTable from '../../Layout/Dashboard/LyTable'
import useTableColumns from './useTableColumns'
import { QueryStatusEnum } from '../../config/QueryStatus'
import { useNavigate } from 'react-router-dom'
import AddButton from '../../Layout/Dashboard/AddButton/AddButton'
import { useGetSupportMessages } from '../../api/supportmessages'
import SearchField from '../../Layout/Dashboard/SearchField'

function Page() {

    const column   =useTableColumns()
    const {data  ,status } = useGetSupportMessages()
    const navigate = useNavigate()
    const totalRows = data?.meta?.total;
    
  return (
    // Pass Status to Layout 
    <DashBody status={status as QueryStatusEnum} >
      <DashHeader showAddButton={false} title={'SupportMessages'}>
      <div className='RightSide d-flex gap-2 align-center '>
     <SearchField searchBy={"email"} />

     {/* <AddButton  onClick={()=>navigate('/support_messages/add')}></AddButton> */}
     </div>
      </DashHeader>
      
      <LyTable
        data={data?.data}
        isLoading={false}
        columns={column}
        total={totalRows }
        is_pagination={true}
    />
      
    
    </DashBody>
  )
}

export default Page

